import {Component, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {CategorySimpleSearchModel} from "../category-simple-search.model";
import {CategorySearchPageComponent} from "../category-search-page/category-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-category-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(CategorySimpleSearchModel),
        registerSearchControl(CategoryMultiSelectSearchControlComponent)
    ]
})
export class CategoryMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<CategorySimpleSearchModel> implements OnInit {
    @Input() maxLevel: number;

    constructor(model: CategorySimpleSearchModel, injector: Injector) {
        super(model, injector, "categoryId", "name");
        this.extendedSearchComponent = CategorySearchPageComponent;
    }

    ngOnInit(): void {
        this.model.filter[CategorySimpleSearchModel.MAX_LEVEL_FILTER_NAME] = this.maxLevel;
    }
}
